import { mapGetters, mapState } from 'vuex';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import StandardForm from '@/components/sections/Login/StandardForm/StandardForm.vue';
import SAMLStarter from '@/components/sections/Login/SAMLStarter/SAMLStarter.vue';
import SAMLForm from '@/components/sections/Login/SAMLForm/SAMLForm.vue';

// @vue/component
export default {
  name: 'Login',
  components: {
    PageHeader,
    standard: StandardForm,
    'saml-first': SAMLStarter,
    'saml-email': SAMLForm,
  },
  computed: {
    ...mapGetters({
      samlURL: 'samlURL',
      googleSSOURL: 'googleSSOURL',
    }),
    ...mapState({
      loginType: (state) => state.login.loginType,
      loginState: (state) => state.login.loginState,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/Login/Login.js